import { gameConfigInput } from "./game.config.ts";
import { parseGameConfig, resolveGameConfig } from "./resolve.ts";

export const packagedGameConfig = parseGameConfig(gameConfigInput);
export const defaultGameConfig = resolveGameConfig(packagedGameConfig);

export {
  HOUSE_IDS,
  featureFlagsSchema,
  gameConfigSchema,
  houseIdSchema,
  houseManifestSchema,
  houseStatusSchema,
  networkBudgetSchema,
  remoteConfigOverrideSchema,
} from "./schema.ts";
export type {
  EconomyConfig,
  FeatureFlags,
  GameConfig,
  HouseId,
  HouseManifest,
  HouseStatus,
  NetworkBudget,
  RemoteConfigOverride,
} from "./schema.ts";

export { IMPLEMENTED_HOUSE_IDS } from "./implemented-houses.ts";
export {
  getHouse,
  isHouseImplemented,
  isHousePlayable,
  parseGameConfig,
  parseRemoteOverride,
  playableHouseIds,
  resolveFlag,
  resolveGameConfig,
  resolveHouseStatus,
} from "./resolve.ts";
export {
  firstClearGold,
  firstThreeStarBonusGold,
  replayGold,
} from "./rewards.ts";
